/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var XCircleIcon20Regular = forwardRef('XCircleIcon20Regular', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 20 }, props),
        React.createElement("path", { d: "M7.958 6.897a.75.75 0 1 0-1.061 1.06L8.94 10l-2.043 2.043a.75.75 0 0 0 1.06 1.06L10 11.061l2.043 2.042a.75.75 0 1 0 1.06-1.06L11.061 10l2.042-2.043a.75.75 0 0 0-1.06-1.06L10 8.939 7.958 6.897Z" }),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M10 2.001A7.999 7.999 0 1 0 10 18 7.999 7.999 0 0 0 10 2Zm-6.499 8A6.499 6.499 0 1 1 16.5 10 6.499 6.499 0 0 1 3.5 10Z" })));
});
